var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItem4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14.2236C10.866 14.2236 14 11.0896 14 7.22363C14 3.35764 10.866 0.223633 7 0.223633C3.13401 0.223633 0 3.35764 0 7.22363C0 11.0896 3.13401 14.2236 7 14.2236ZM7 9.38184C8.19194 9.38184 9.1582 8.41558 9.1582 7.22363C9.1582 6.03169 8.19194 5.06543 7 5.06543C5.80806 5.06543 4.8418 6.03169 4.8418 7.22363C4.8418 8.41558 5.80806 9.38184 7 9.38184ZM6.5 9.32362V14.2236H7.5V9.32362C7.33953 9.36169 7.17212 9.38184 7 9.38184C6.82788 9.38184 6.66047 9.36169 6.5 9.32362ZM5.86942 9.06237L2.40437 12.5274L1.69727 11.8203L5.16207 8.35551C5.33934 8.64275 5.58205 8.8853 5.86942 9.06237ZM4.90001 7.72363C4.86194 7.56316 4.8418 7.39575 4.8418 7.22363C4.8418 7.05152 4.86194 6.88411 4.90001 6.72363H0V7.72363H4.90001ZM5.16201 6.09185C5.33926 5.8046 5.58197 5.56204 5.86933 5.38496L2.4043 1.91992L1.69719 2.62703L5.16201 6.09185ZM6.5 5.12364C6.66047 5.08558 6.82788 5.06543 7 5.06543C7.17212 5.06543 7.33953 5.08558 7.5 5.12364V0.223633H6.5V5.12364ZM8.13188 5.3857C8.41911 5.56297 8.66166 5.80569 8.83873 6.09306L12.3039 2.62792L11.5968 1.92082L8.13188 5.3857ZM9.09999 6.72363C9.13806 6.88411 9.1582 7.05152 9.1582 7.22363C9.1582 7.39575 9.13806 7.56316 9.09999 7.72363H14V6.72363H9.09999ZM8.83868 8.3543C8.66159 8.64166 8.41903 8.88437 8.13178 9.06162L11.5967 12.5265L12.3038 11.8194L8.83868 8.3543Z",
    fill: "url(#paint0_linear_284_25105)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2917 2.6543L8.83594 6.11005L9.08881 6.71211H13.9774C13.9774 6.71211 13.9116 5.61365 13.483 4.56946C13.0544 3.52527 12.2917 2.6543 12.2917 2.6543Z",
    fill: "#AD916F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40625 1.90948L5.862 5.36523L6.46407 5.11236L6.46407 0.223745C6.46407 0.223745 5.36561 0.289535 4.32142 0.718166C3.27722 1.1468 2.40625 1.90948 2.40625 1.90948Z",
    fill: "#AD916F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49827 0.192158V5.07933L8.10281 5.32624L11.5596 1.86947C11.5596 1.86947 10.7363 1.13926 9.69489 0.703995C8.65344 0.268728 7.49827 0.192158 7.49827 0.192158Z",
    fill: "#AD916F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_284_25105",
    x1: 7,
    y1: 0.223633,
    x2: 7,
    y2: 14.2236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675950"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#46372F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem4);
export default __webpack_public_path__ + "static/media/item4.a9d74c1a6a7e5702a55d1a7325aefe5c.svg";
export { ForwardRef as ReactComponent };